import axios from "axios";
import { ExternalLink, ShoppingBag, Gauge, MonitorPlay, GraduationCap } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AFF_ICONS = {
  equipement: ShoppingBag,
  performance: Gauge,
  logiciel: MonitorPlay,
  formation: GraduationCap,
};

export default function AffiliateCard({ aff, compact = false }) {
  const { t } = useLang();
  const Icon = AFF_ICONS[aff.categorie] || ShoppingBag;

  const open = () => {
    axios.post(`${API}/affiliates/${aff.id}/clic`).catch(() => {});
    window.open(aff.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      data-testid={`affiliate-card-${aff.id.slice(0, 8)}`}
      className="group border border-[#27272A] bg-[#121214] p-6 flex flex-col hover:border-[#C5A059]/60 hover:-translate-y-1 transition-all duration-300"
    >
      <div className="flex items-start justify-between mb-4">
        {aff.image ? (
          <img src={aff.image} alt={aff.nom} className="h-12 w-12 object-cover border border-[#27272A]" />
        ) : (
          <div className="h-12 w-12 flex items-center justify-center border border-[#C5A059]/30 bg-[#C5A059]/5 text-[#C5A059] font-display font-bold text-lg">
            {aff.nom.charAt(0)}
          </div>
        )}
        <div className="flex items-center gap-2">
          {aff.badge && (
            <span className="text-[9px] uppercase tracking-widest border border-[#C5A059]/50 text-[#C5A059] px-2 py-0.5">{aff.badge}</span>
          )}
          <Icon size={16} className="text-[#71717A]" />
        </div>
      </div>
      <h3 className="font-display uppercase font-bold text-base leading-tight">{aff.nom}</h3>
      {!compact && aff.description && <p className="text-xs text-[#A1A1AA] mt-2 leading-relaxed flex-1">{aff.description}</p>}
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-[#27272A]/60">
        <span className="text-[9px] uppercase tracking-widest text-[#52525B]">{t("aff.badge")}</span>
        <button
          onClick={open}
          data-testid={`affiliate-cta-${aff.id.slice(0, 8)}`}
          className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-[#C5A059] hover:text-[#E5C07B] transition-colors"
        >
          {t("aff.cta")} <ExternalLink size={11} />
        </button>
      </div>
    </div>
  );
}
